import Vue from "vue";
import { requiredParam } from "@utils/func";

Vue.prototype.$handleErrorResponse = function ({
  title = requiredParam("title"),
  errorMessages = requiredParam("errorMessages"),
  actions = [],
} = {}) {
  errorMessages.forEach((text) => {
    Vue.prototype.$notify({
      group: "system",
      title,
      text,
      data: {
        type: "danger",
        actions: [
          ...actions,
          {
            name: "Close",
            onClick: (close) => close(),
          },
        ],
      },
    });
  });
};
